import React, { Component } from 'react';
import { getUserData } from '../helpers/Common';
import NoticeBoard from './qlink_partials/NoticeBoard';
import NewPost from './qlink_partials/NewPost';
import DoyouKnow from './qlink_partials/DoyouKnow';
import SupportDesk from './qlink_partials/SupportDesk';
export default class Qlinks extends Component {
	constructor(props) {
		super(props);
		this.redirect = this.redirect.bind(this);
	}
	redirect(type) {
		this.props.switchPanel(type);
	}
  render() {
    let is_careerlauncher = getUserData('is_careerlauncher', true);
    let productid = getUserData('productID', true);
    return (
      <div id="qlinks">
		    <SupportDesk/>
        <NoticeBoard />
        { !is_careerlauncher && (productid != 418 && productid != 419) ? <div><DoyouKnow /></div> : '' }
        { !is_careerlauncher && (productid != 418 && productid != 419) ? <div><NewPost redirectprops={this.redirect}/></div> : ''}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/partials/Qlinks.js